<template>
  <div
    :class="[
      $style.container,
      center && $style.center,
      shadowless && $style.shadowless,
      borderless && $style.borderless,
      radiusless && $style.radiusless,
    ]"
  >
    <slot> </slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Card extends Vue {
  @Prop({ default: false })
  public center!: boolean;

  @Prop({ default: false })
  public shadowless!: boolean;

  @Prop({ default: false })
  public borderless!: boolean;

  @Prop({ default: false })
  public radiusless!: boolean;
}
</script>

<style lang="scss" module>
.container {
  min-height: 100px;
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-bottom: 2rem;
  padding: 20px;
  box-shadow: 0 6px 6px $grey-border;
  border: 0.5px solid $grey-border;
  border-radius: 6px;
  background-color: #fbfbfb;
}

.center {
  align-items: center;
  justify-content: center;
}

.shadowless {
  box-shadow: none;
}

.borderless {
  border: none;
}

.radiusless {
  border-radius: 0;
}
</style>
